"use client";

// EnterPill — the door from a public surface INTO the app ("yours"). The brand
// pill, compact: label left, a white disc holding NETTI'S OWN MARK (law_buttons:
// netti is the mark for begin/enter, so a door into the experience always reads
// as netti). The mark turns a hair on hover so the door feels alive. Sits
// top-right of the crumb header; hidden once you're already signed in — so the
// label says what a stranger actually does HERE. On most surfaces that is
// "create yours". On the commons, where every card is a skill someone is
// offering, the thing you actually want is to keep one: "save it".

import { PillButton } from "./ui";
import BrandIcon from "./BrandIcon";

export default function EnterPill({
  onClick,
  label = "create yours",
  ariaLabel = "create your innernet",
}: {
  onClick: () => void;
  /** what this door does on THIS surface. */
  label?: string;
  ariaLabel?: string;
}) {
  return (
    <PillButton
      variant="primary"
      className="enter-pill btn-pill--solid"
      onClick={onClick}
      aria-label={ariaLabel}
      icon={<BrandIcon name="innernet" size={17} className="pill-netti" />}
    >
      {label}
    </PillButton>
  );
}
